
import { Component, Vue, Prop} from 'vue-property-decorator';
import IncomeOtherPersonHouseholdFsSurvey from "./IncomeOtherPersonHouseholdFSSurvey.vue";
import PageBase from "../../PageBase.vue";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
import { stepInfoType, stepResultInfoType } from "@/types/Application";
import { togglePages } from '@/components/utils/TogglePages';

@Component({
    components:{
        IncomeOtherPersonHouseholdFsSurvey,
        PageBase
    }
})
export default class IncomeOtherPersonHouseholdFS extends Vue {

    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep =0;
    currentPage =0;
    showTable = true;

    incomeOtherPersonHouseholdLiveAlone = null;
    incomeOtherPersonHouseholdNumberOfChildren = 0;
    incomeOtherPersonHouseholdLiveWithAdult = null;

    adultData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('income-other-person-household-fs-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {       
        this.showTable = value;
    }

    public populateSurveyData(childValue) {

        const currentIndexValue = this.adultData?.length > 0 ? this.adultData[this.adultData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newChild = { ...childValue, id };
        this.adultData = [...this.adultData, newChild];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
       
        this.adultData = this.adultData.filter(data => {
            return data.id !== rowToBeDeleted;
        });
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.adultData = this.adultData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
    }

    public onPrev() {
       Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    created() {

        if (this.step.result?.incomeOtherPersonHouseholdLiveAlone) {
            this.incomeOtherPersonHouseholdLiveAlone = this.step.result.incomeOtherPersonHouseholdLiveAlone;
        }

        if (this.step.result?.incomeOtherPersonHouseholdNumberOfChildren) {
            this.incomeOtherPersonHouseholdNumberOfChildren = this.step.result.incomeOtherPersonHouseholdNumberOfChildren;
        }

        if (this.step.result?.incomeOtherPersonHouseholdLiveWithAdult) {
            this.incomeOtherPersonHouseholdLiveWithAdult = this.step.result.incomeOtherPersonHouseholdLiveWithAdult;
        }

        if (this.step.result?.incomeOtherPersonHouseholdFSSurvey?.data) {
            this.adultData = this.step.result.incomeOtherPersonHouseholdFSSurvey.data;
        }
             
    }

    mounted(){
        Vue.nextTick(()=>this.surveyHasError());
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;   
        this.liveWithAdultChanged();     
    }

    public surveyHasError(){
        let progress = this.adultData.length==0? 50 : 100;
        
        if(this.incomeOtherPersonHouseholdLiveAlone == 'Yes') progress =100;

        this.incompleteError =  false;        
        for(const adult of this.adultData){
            if ((this.incomeOtherPersonHouseholdLiveAlone=='No' && this.incomeOtherPersonHouseholdLiveWithAdult == 'Yes') && 
                (!adult.adultFullName || !adult.adultAnnualIncome || !adult.married )){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }    

        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }

    public isDisableNext() {
        return (!this.incomeOtherPersonHouseholdLiveAlone || 
            (this.incomeOtherPersonHouseholdLiveAlone == 'No' && 
            (!this.incomeOtherPersonHouseholdLiveWithAdult || this.incomeOtherPersonHouseholdLiveWithAdult == 'Yes') 
            && this.adultData?.length <= 0 ));
    }

    beforeDestroy() {
        this.surveyHasError();  
        
        let adultInfo = this.getAdultResults()        
        
        if(this.incomeOtherPersonHouseholdLiveAlone == 'Yes' ||
                (this.incomeOtherPersonHouseholdLiveAlone == 'No' && this.incomeOtherPersonHouseholdLiveWithAdult == 'No'))
            adultInfo = null
        
        this.UpdateStepResultData(
                {
                    step:this.step,
                    data: {
                        incomeOtherPersonHouseholdLiveAlone: this.incomeOtherPersonHouseholdLiveAlone, 
                        incomeOtherPersonHouseholdNumberOfChildren: this.incomeOtherPersonHouseholdNumberOfChildren,
                        incomeOtherPersonHouseholdLiveWithAdult: this.incomeOtherPersonHouseholdLiveWithAdult,
                        incomeOtherPersonHouseholdFSSurvey: adultInfo
                    }
                }
            )       
    }

    public getAdultResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        for(const adult of this.adultData)
        {
            questionResults.push({name:'incomeOtherPersonHouseholdFSSurvey', value: this.getAdultInfo(adult), title:'Adult '+adult.id +' Information', inputType:''})
        }
        
        return {data: this.adultData, questions:questionResults, pageName:'Income of Other Persons in Household', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getAdultInfo(adult){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Name: ")+(adult.adultFullName));
        resultString.push(Vue.filter('styleTitle')("Annual Income: ")+(adult.adultAnnualIncome))
        resultString.push(Vue.filter('styleTitle')("Relationship to you: ")+(adult.married == 'y'?'Married/Cohabitating': 'Not Married/Cohabitating'))           
        
        return resultString
    } 

    public liveWithAdultChanged(){
        
        if(this.incomeOtherPersonHouseholdLiveWithAdult){
            togglePages([this.stPgNo.FS.ContributionTowardExpensesFS], this.incomeOtherPersonHouseholdLiveWithAdult == 'Yes', this.currentStep);
        }
    }
    
}
